import { registerStyles } from "../utils/registerStyles";
import React from "react";

export default function LoadingIndicator({ message = "Laddar...", fullPage = false, className = "" }) {
  return (
    <div
      className={`loading-indicator${fullPage ? " loading-indicator--page" : ""}${className ? ` ${className}` : ""}`}
      role="status"
      aria-live="polite"
    >
      <span className="loading-indicator__spinner" aria-hidden="true" />
      <span className="loading-indicator__message">{message}</span>
    </div>
  );
}

// Styles live with this component; keep selectors and responsive rules together.
registerStyles("LoadingIndicator", `
.loading-indicator {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 14px;
  min-height: 100px;
  padding: 24px;
  box-sizing: border-box;
  color: #6b7280;
  text-align: center;
}

.loading-indicator--page {
  min-height: 400px;
  width: 100%;
}

.loading-indicator__spinner {
  width: 42px;
  height: 42px;
  border: 4px solid #e9e4fb;
  border-top-color: #6323ef;
  border-radius: 50%;
  box-sizing: border-box;
  animation: loading-indicator-spin 0.8s linear infinite;
}

.loading-indicator__message {
  font-size: 14px;
  font-weight: 500;
  line-height: 1.4;
}

@keyframes loading-indicator-spin {
  to { transform: rotate(360deg); }
}

@media (prefers-reduced-motion: reduce) {
  .loading-indicator__spinner { animation-duration: 2s; }
}
`);
